import React from "react";
import { Row, Col } from "antd";
import CardHeader from "../../../components/atoms/cardHeader";

export const Payment = ({ data }) => {
  return (
    <>
      <div className="card card-custom mb-5">
        <CardHeader name={"Payment Information"} />

        <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-2">
          <Row gutter={[30, 30]}>
            <Col className="gutter-row" xs={24} lg={24}>
              <div className="table-responsive">
                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <td>
                        <tr>
                          {" "}
                          <td className="">Amount</td>
                        </tr>
                        <tr>
                          <td className="">Method</td>
                        </tr>
                        <tr>
                          <td className="">Gateway</td>
                        </tr>
                      </td>

                      <>
                        {data?.map((val, index) => {
                          return (
                            <>
                              <td style={{ borderLeft: "1px solid #ccc" }}>
                                <tr>
                                  <td className="">
                                    <span className="text-muted">
                                      {val?.amount}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="">
                                    <span className="text-muted">
                                      {val?.paymentMethod}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="">
                                    <span className="text-muted">
                                      {val?.gateway}
                                    </span>
                                  </td>
                                </tr>
                              </td>
                            </>
                          );
                        })}
                      </>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
